import { useNavigate } from 'react-router-dom'

import { PageHeader, Spinner } from '../../../Components'
import { getDateObj } from '../../../Services/Functions'
import { cap } from '../../../State'
import { translations } from '../../../translations'
import { handleBilledConversation } from '../billedFunctions'
import { handleGenerateExcel } from '../reportFunctions'

const language = cap.language.state || 'IT'
const t = translations[language] || translations.IT

/**
 * Formatta un intervallo date per il sottotitolo pagina statistiche.
 * @param {string} startDate - Data inizio (dd/mm/yyyy)
 * @param {string} endDate - Data fine (dd/mm/yyyy)
 * @returns {string} Testo descrittivo del periodo selezionato
 */
function formatPeriodSubtitle(startDate, endDate) {
  const opts = { day: '2-digit', month: 'long', year: 'numeric' }
  const start = getDateObj(startDate)?.toLocaleDateString('it-IT', opts) || startDate
  const end = getDateObj(endDate)?.toLocaleDateString('it-IT', opts) || endDate
  return `${t.stPeriodoSelezionato} ${start} — ${end}`
}

/**
 * Header della pagina Statistiche con titolo e azioni (Dashboard €, Esporta Report, Segna come fatturato).
 * @param {Object} props
 * @param {boolean} props.isAdmin - Se l'utente è admin
 * @param {boolean} props.isFatturazione - Se l'utente è in ruolo fatturazione
 * @param {boolean} props.spinnerOperation - Se è in corso un'operazione con spinner
 * @param {string} props.startDate - Data inizio periodo (dd/mm/yyyy)
 * @param {string} props.endDate - Data fine periodo (dd/mm/yyyy)
 * @param {Object} props.data - Dati dashboard per l'export
 * @param {Object} props.totalPriceGeneral - { counter, total } per il bottone fatturato
 * @param {Function} props.setSpinnerOperation - Setter per lo stato spinner
 * @returns {JSX.Element}
 */
export function StatisticsHeader({
  isAdmin,
  isFatturazione,
  spinnerOperation,
  startDate,
  endDate,
  data,
  totalPriceGeneral,
  setSpinnerOperation
}) {
  const navigate = useNavigate()

  return (
    <PageHeader
      title={t.statistics}
      subtitle={formatPeriodSubtitle(startDate, endDate)}
      actions={
        <>
          {isAdmin && !spinnerOperation && (
            <>
              <button type="button" className="nbtn" onClick={() => navigate('/dashboardPricing')}>
                {t.stDashboardEuro}
              </button>
              <button
                type="button"
                className="nbtn nbtn--primary"
                onClick={() => handleGenerateExcel(startDate, endDate, data)}
              >
                <i className="pi pi-chart-bar" style={{ fontSize: 14 }} />
                {t.stEsportaReport}
              </button>
            </>
          )}
          {isFatturazione && totalPriceGeneral?.counter > 0 && !spinnerOperation && (
            <button
              type="button"
              className="nbtn nbtn--primary"
              onClick={() => handleBilledConversation(startDate, endDate, setSpinnerOperation)}
            >
              {t.stSegnaFatturato}
            </button>
          )}
          {spinnerOperation && <Spinner size={28} />}
        </>
      }
    />
  )
}
